//Google Analytics Scripts started here
let NoOfFaildAttempt = 0;
let NoOfSuccessfulAttempt = 0;
let typingstartTime = null;
let blurTime = null;
let stepStartTime = null;
let timeTakentoFillThisField = null;
let timeTakentoFillTheForm = null;
let errorText = null;
let stepTime = null;
let fieldsArray = [];

if (window.sessionStorage.getItem('totalStepTime') == null)
    window.sessionStorage.setItem('totalStepTime', new Date().getTime());

var url = window.location.href;
parts = url.split('/');
lastPart = parts[parts.length - 1];

if (stepStartTime === null) {
    stepStartTime = new Date().getTime();
}

function setTotalFieldTime(timeTakentoFillThisField) {
    if (window.sessionStorage.getItem('SumOftotalFieldTime') == null)
        window.sessionStorage.setItem('SumOftotalFieldTime', timeTakentoFillThisField);
    else
        window.sessionStorage.setItem('SumOftotalFieldTime', parseFloat(window.sessionStorage.getItem('SumOftotalFieldTime')) + timeTakentoFillThisField);
}

function getTotalFieldTimeOnAllAttempts(fieldName, timeTakentoFillThisField) {
    let totalfieldTime = 0;
    if (fieldsArray == null || fieldsArray.length == 0) {
        let fieldArray = {
            filedName: fieldName,
            totalfieldTime: timeTakentoFillThisField
        }
        fieldsArray.push(fieldArray);
    } else {
        let filterArray = fieldsArray.findLast(f => f.filedName == fieldName);
        if (filterArray != undefined) {
            filterArray.totalfieldTime = filterArray.totalfieldTime + timeTakentoFillThisField;
        } else {
            fieldsArray.push({
                filedName: fieldName,
                totalfieldTime: timeTakentoFillThisField
            });
        }
    }

    totalfieldTime = fieldsArray.findLast(f => f.filedName == fieldName).totalfieldTime;
    return totalfieldTime;
}

//GA4 Scripts for OnClick of Loan application Main-form,Short-form,Contactus-form fields	
//GA4 Scripts when a form field is filled in, an error occurs in a form field, or a field is left blank for Main-form - starts
$('form input[type="text"]').on('focus', function (e) {
    typingstartTime = new Date().getTime();
});

$('form input[type="text"]').on('blur', function (e) {

    let blankField = $(e.currentTarget).val().length = 0 ? "error" : "empty";
    let label = $(e.currentTarget).parent().find("label").text();
    errorText = null;

    if (typingstartTime !== null) {
        blurTime = new Date().getTime();
        timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
        stepTime = (typingstartTime - stepStartTime) / 1000;
    }

    setTotalFieldTime(timeTakentoFillThisField);
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(this.attributes["data-sc-field-name"].value, timeTakentoFillThisField);

    let checkValid = null
    if ($(e.currentTarget).valid()) {
        checkValid = "Filled";
    }
    else {
        checkValid = "Error";
    }

    if (checkValid == "Error") {
        errorText = $(e.currentTarget).parent().parent().find("span.form-error").text();
    }

    var category;
    if (url.match(/application/)) {
        category = "Main form – Form Field";
    }
    else if ($('form').hasClass('Contact-us')) {
        category = "Contact form – Form field";
    }
    else if ($('form').hasClass('short-form')) {
        category = "Short form (request a call) – Form field";
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gaevent',
        'step_name': lastPart,
        'category': category,
        'action': checkValid,
        'label': label,
        'fieldTime': timeTakentoFillThisField,
        'fieldError': blankField,  //`empty` or `error`
        'field_error_message': errorText,
        'stepTime': stepTime,
        'total_fieldTime': totalFieldTimeOnAllAttempts
    });
});
//GA4 Scripts when a form field is filled in, an error occurs in a form field, or a field is left blank for Main-form- ends

//GA4 Scripts for OnClick of Next/back/submit button in Main-form,Short-form,Contactus-form starts
$('form input[type="submit"]').on('click', function () {
    var action = $(this).val();
    var url = window.location.href;
    var category, total_stepsTime, validationResult = 'INVALID';

    var arrayOfObject = [];

    if (stepStartTime !== null) {
        blurTime = new Date().getTime();
        timeTakentoFillThisField = (blurTime - stepStartTime) / 1000;

        if (window.sessionStorage.getItem('totalStepTime') != null) {
            total_stepsTime = (blurTime - window.sessionStorage.getItem('totalStepTime')) / 1000;
        }
    }

    var totalTimeTakenToFillAllFields = window.sessionStorage.getItem('SumOftotalFieldTime') != null ? window.sessionStorage.getItem('SumOftotalFieldTime') : timeTakentoFillThisField;

    if (url.match(/application/)) {
        category = "Main form – Button click";
    }
    else if ($('form').hasClass('Contact-us')) {
        category = "Contact form – Button click";
    }
    else if ($('form').hasClass('short-form')) {
        category = "Short form (request a call) – Button click";
    }
    window.dataLayer = window.dataLayer || [];
    var pageurl = $(location).attr('href');

    if ($('form').valid()) {
        validationResult = 'VALID';
        window.sessionStorage.setItem('SumOftotalFieldTime', 0);
    }
    else {
        $('input[data-sc-field-name], select[data-sc-field-name]').not(':hidden').each(function () {
            var fieldObject = {
                filedName: this.attributes["data-sc-field-name"].value,
                fieldError: $(this).valid() ? "undefined" : this.value == null || this.value.trim().length == 0 ? "empty" : "error",
                field_error_message: $(this).closest('.form-input-group').find('span.form-error').text()
            }
            arrayOfObject.push(fieldObject);
        });
    }
    dataLayer.push({
        'event': 'stepValidation',
        'step_name': lastPart,
        'category': category,
        'validationResult': validationResult,
        'action': action,
        'label': pageurl,
        'stepTime': totalTimeTakenToFillAllFields,
        'total_stepsTime': total_stepsTime,
        'stepErrors': arrayOfObject
    });
});
//GA4 Scripts for OnClick of Next/back/submit button in Main-form,Short-form,Contactus-form ends


//GA4 Scripts for Onclick of Checkbox in Main-form,Short-form,Contactus-form	
$('form input[type="checkbox"]').on('click', function () {
    let error = null;

    typingstartTime = new Date().getTime();
    blurTime = null;
    errorText = null;
    let action;

    $(this).valid();

    if ($(this).is(':checked')) {
        action = "Checked";
    }
    else {
        action = "Unchecked";
        error = "Error";
        errorText = $(this).closest('.form-input-group').find('span.form-error').last().text();
    }

    blurTime = new Date().getTime();
    timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
    stepTime = (typingstartTime - stepStartTime) / 1000;
    setTotalFieldTime(timeTakentoFillThisField);
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(this.attributes["data-sc-field-name"].value, timeTakentoFillThisField);

    var label = $(this).attr('data-sc-field-name');
    var category;
    var url = window.location.href;
    if (url.match(/application/)) {
        category = "Main form – Consent checkbox";
    }
    else if (url.match(/checklist-consent/)) {
        category = "Main form – Consent checkbox";
    }
    else if ($('form').hasClass('Contact-us')) {
        category = "Contact form – Consent checkbox";
    }
    else if ($('form').hasClass('short-form')) {
        category = "Short form (request a call) – Consent checkbox";
    }
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gaevent',
        'step_name': lastPart,
        'category': category,
        'action': action,
        'label': label,
        'fieldTime': timeTakentoFillThisField,
        'stepTime': stepTime,
        'fieldError': error,  //`empty` or `error`
        'field_error_message': errorText,
        'total_fieldTime': totalFieldTimeOnAllAttempts
    });
});

//GA4 Scripts for Onclick of Question Box button in Loan Application Main form

$('input[type="radio"]').eq(0).closest('.form-input-group').find('.checkbox-choosed').on('click', (e) => {
    var label = $('input[type="radio"]').attr('data-sc-field-name');
    var action;
    typingstartTime = new Date().getTime();

    if ($('.checkbox-choosed a.checkbox-choosed-yes').hasClass('active')) {
        action = $('.checkbox-choosed a.checkbox-choosed-yes.active').text();
    }
    else if ($('.checkbox-choosed a.checkbox-choosed-no').hasClass('active')) {
        action = $('.checkbox-choosed a.checkbox-choosed-no.active').text();
    }
    var url = window.location.href;
    stepTime = (typingstartTime - stepStartTime) / 1000;
    blurTime = new Date().getTime();
    timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(label, timeTakentoFillThisField);

    if (url.match(/psd2stage1/)) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'label': label,
            'kontomatik': action,
            'stepTime': stepTime,
            'total_fieldTime': totalFieldTimeOnAllAttempts
        });
    }
    else {
        setTotalFieldTime(timeTakentoFillThisField);

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Main form – Question checkbox',
            'action': action,
            'label': label,
            'stepTime': stepTime,
            'total_fieldTime': totalFieldTimeOnAllAttempts
        });
    }
});

//GA4 Scripts for Onclick of Beneficiary Question Box button in Statement page 
$('input[data-validator-id="benrealbeneficiary"]').eq(0).closest('.form-input-group').find('.checkbox-choosed').on('click', (e) => {
    var label = $('input[data-validator-id="benrealbeneficiary"]').attr('data-sc-field-name');
    var action;
    if ($('.checkbox-choosed a.checkbox-choosed-yes').hasClass('active')) {
        action = $('.checkbox-choosed a.checkbox-choosed-yes.active').text();
    }
    else if ($('.checkbox-choosed a.checkbox-choosed-no').hasClass('active')) {
        action = $('.checkbox-choosed a.checkbox-choosed-no.active').text();
    }
    typingstartTime = new Date().getTime();
    stepTime = (typingstartTime - stepStartTime) / 1000;

    blurTime = new Date().getTime();
    timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(label, timeTakentoFillThisField);

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gaevent',
        'category': 'Main form – Question checkbox',
        'action': action,
        'label': label,
        'stepTime': stepTime,
        'total_fieldTime': totalFieldTimeOnAllAttempts
    });
});

// GA4 Scripts for Onclick of has bank list question box button in PSD2 page
$('input[data-validator-id="bank-list-present"]').eq(0).closest('.form-input-group').find('.checkbox-choosed').on('click', (e) => {
    var label = $('input[data-validator-id="bank-list-present"]').attr('data-sc-field-name');
    var action;
    if ($('.BANK-LIST-PRESENT.checkbox-choosed-wrap .checkbox-choosed a.checkbox-choosed-yes').hasClass('active')) {
        action = $('.BANK-LIST-PRESENT.checkbox-choosed-wrap .checkbox-choosed a.checkbox-choosed-yes.active').text();
    }
    else if ($('.BANK-LIST-PRESENT.checkbox-choosed-wrap .checkbox-choosed a.checkbox-choosed-no').hasClass('active')) {
        action = $('.BANK-LIST-PRESENT.checkbox-choosed-wrap .checkbox-choosed a.checkbox-choosed-no.active').text();
    }
    typingstartTime = new Date().getTime();
    stepTime = (typingstartTime - stepStartTime) / 1000;

    blurTime = new Date().getTime();
    timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(label, timeTakentoFillThisField);

    var url = window.location.href;
    if (url.match(/psd2stage1/)) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'label': label,
            'kontomatik': action,
            'stepTime': stepTime,
            'total_fieldTime': totalFieldTimeOnAllAttempts
        });
    }
});

//GA4 Scripts for Onselect of Dropdown in Loan Application Form
$('form select').on('focus', function (e) {
    typingstartTime = new Date().getTime();
    var label = $(this).closest('.form-input-group').find("label").text();

    let error = null; let action = null;
    blurTime = null;
    errorText = null;

    let DDValue = $(this).closest('.form-input-group').find('select').val();

    if ($(this).length && DDValue != undefined && DDValue.trim().length > 0) {
        action = "Selected";

        errorText = $(this).closest('.form-input-group').find('span.form-error').text();
        if (errorText.trim().length != 0) {
            error = "Error";
        }
    }
    else {
        action = "Not Selected";
        error = "Error";
        errorText = $(this).closest('.form-input-group').find('span.form-error').text();
    }

    blurTime = new Date().getTime();
    timeTakentoFillThisField = (blurTime - typingstartTime) / 1000;
    stepTime = (typingstartTime - stepStartTime) / 1000;

    setTotalFieldTime(timeTakentoFillThisField);
    let totalFieldTimeOnAllAttempts = getTotalFieldTimeOnAllAttempts(this.attributes["data-sc-field-name"].value, timeTakentoFillThisField);

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gaevent',
        'step_name': lastPart,
        'category': 'Main form – Drop down list field',
        'action': action,
        'label': label,
        'fieldTime': timeTakentoFillThisField,
        'fieldError': error,  //`empty` or `error`
        'field_error_message': errorText,
        'stepTime': stepTime,
        'total_fieldTime': totalFieldTimeOnAllAttempts
    });
});

//GA4 Scripts for On page load of PSD2 pages

$(document).ready(function () {
    var url = window.location.href;
    var label;
    var step;

    if (url.match(/psd2stage1/)) {
        label = "step 8.1 psd2stage1";
        step = "8.1";
    }
    if (url.match(/psd2paymentverification/)) {
        label = "step 8.2 psd2paymentverification";
        step = "8.2";
    }
    if (url.match(/stage2-psd2-page3/)) {
        label = "step 8.3 stage2-psd2-page3";
        step = "8.3";
    }
    if (url.match(/psd2disbursementaccount/)) {
        label = "step 9.1 psd2disbursementaccount";
        step = "9.1";
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'gaevent',
        'label': label,
        ecommerce: {
            checkout: {
                actionField: {
                    step: step,
                },
            }
        }
    });
});
//Google Analytics Scripts ended here